import React from 'react';

function TestimonialItem({ heading, desc, clientName, clientRole, thumb }) {
  return (
    <div className="slider-item">
      <div className="row">
        <div className="col-lg-6">
          <div className="slider-card">
            <div className="card-content">
              <h3 className="card-heading">{heading}</h3>
              <p className="body-text">{desc}</p>
              <div className="client-info">
                <h4 className="client-name">{clientName}</h4>
                <span className="client-role">{clientRole}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="slider-thumb bg-cover"
            style={{ backgroundImage: `url(${thumb})` }}
          />
        </div>
      </div>
    </div>
  );
}

export default TestimonialItem;
